import { createReducer } from '@reduxjs/toolkit';
import { LIST_VIEW } from './models';
import { SwitchViewState } from './models/switchView.interfaces';
import { svSelectView } from './switchView.actions';

const INITIAL_STATE: SwitchViewState = {
  disabled: true,
  selectedView: LIST_VIEW
};

const switchViewReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase( svSelectView, (state, action) => ({
      ...state,
      selectedView: action.payload
    }));
});

export default switchViewReducer;